'use client'
import { MainHeader } from '@mercedes-benz/oneweb-next-react-components'
import { useEffect, ComponentProps, useState } from 'react'
import { globalData } from '@/store'
import { useAtom } from 'jotai'
import { removeStartEndDoubleQuotes } from '@/utils'
import { getAccountInfo, verifyToken } from '@/services'
import config from '@/config'
import { SuggestionAPI, SearchResultURL } from '@/constants'
import { StorageKey } from '@/constants/storage'

const GlobalHeader = () => {
  const [{ header, vehicleList, userInfo, search }, setGlobalData] = useAtom(globalData)

  const notLogin = () => {
    localStorage.removeItem('MME-TOKEN')
    setGlobalData((prev: any) => ({
      ...prev,
      userInfo: {
        status: 'notLogin',
        username: '',
        userPhone: '',
        loginUrl: prev.userInfo.loginUrl,
        logoutUrl: prev.userInfo.logoutUrl,
      },
    }))
  }

  const removeDraftCta = (data: any) => {
    if (
      data &&
      data.vehicleList &&
      data.vehicleList.vehicleList &&
      data.vehicleList.vehicleList.data &&
      data.vehicleList.vehicleList.data.attributes &&
      data.vehicleList.vehicleList.data.attributes.OWVehicleBody &&
      data.vehicleList.vehicleList.data.attributes.OWVehicleBody.length > 0
    ) {
      data.vehicleList.vehicleList.data.attributes.OWVehicleBody.forEach((body: any) => {
        if (body.OWVehicleClass && body.OWVehicleClass.length > 0) {
          body.OWVehicleClass.forEach((vehicleClass: any) => {
            if (vehicleClass.OWVehicleModel && vehicleClass.OWVehicleModel.length > 0) {
              vehicleClass.OWVehicleModel.forEach((vehicleModel: any) => {
                const vehicleDetail = vehicleModel.vehicleDetail?.data?.attributes
                if (vehicleDetail && vehicleDetail.CTAs && vehicleDetail.CTAs.length > 0) {
                  // 过滤掉 CTAs 中 link.data === null 的项
                  vehicleDetail.CTAs = vehicleDetail.CTAs.filter((cta: any) => cta.link.data !== null)
                }
              })
            }
          })
        }
      })
    }

    return data
  }

  useEffect(() => {
    const username = removeStartEndDoubleQuotes(localStorage?.getItem('realName'))
    const userPhone = removeStartEndDoubleQuotes(localStorage?.getItem('mobile'))
    const preview = sessionStorage.getItem(StorageKey.IS_PREVIEW) === 'true'
    const url = preview ? `/api/global-data?fields=header&preview=${preview}` : '/api/global-data?fields=header'

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const placeholder = data?.data?.header?.data?.attributes.searchPlaceholder || ''
        const bodyStyles = data?.data?.vehicleList?.bodyStyles || []
        // remove the draft CTA if not in preview mode
        const globalData = preview ? data?.data : removeDraftCta(data?.data)
        setGlobalData((prev: any) => ({ ...prev, ...globalData, bodyStyles, search: { placeholder, result: [], suggestionAPI: SuggestionAPI, searchResultURL: SearchResultURL } }))
      })
    verifyToken().then((res) => {
      const status = ['suspended', 'active', 'notLogin'][res] as ComponentProps<typeof MainHeader>['userInfo']['status']
      setGlobalData((prev: any) => ({
        ...prev,
        userInfo: {
          status,
          username,
          userPhone,
          loginUrl: prev.userInfo.loginUrl,
          logoutUrl: prev.userInfo.logoutUrl,
        },
      }))
      if (!localStorage.getItem('realName')) {
        getAccountInfo().then(() => {
          const username = removeStartEndDoubleQuotes(localStorage?.getItem('realName'))
          setGlobalData((prev: any) => ({
            ...prev,
            userInfo: {
              status,
              username,
              userPhone,
              loginUrl: prev.userInfo.loginUrl,
              logoutUrl: prev.userInfo.logoutUrl,
            },
          }))
        })
      }
    })
  }, [setGlobalData])

  const [isMainHeaderPopup, setMainHeaderPopup] = useState(false)
  const handlePopup = (value: boolean) => {
    setMainHeaderPopup(value)
  }

  useEffect(() => {
    setGlobalData((prev: any) => ({
      ...prev,
      mainHeaderPopup: isMainHeaderPopup,
    }))
  }, [isMainHeaderPopup])

  return (
    <>
      {vehicleList && header && (
        <MainHeader
          burgerMenuData={header}
          userInfo={{ ...userInfo, notLogin }}
          vehicleListData={vehicleList}
          search={search}
          occUrl={config.E_STORE_HOST}
          onPopup={handlePopup}
        />
      )}
    </>
  )
}

export default GlobalHeader
